import React from 'react';
import '../../../components/layout/ModuleLayout.css';
import IncidentInsights from '../../../components/incidenceReporting/IncidentInsights';
import IncidentTriage from '../../../components/incidenceReporting/IncidentTriage';
// Incident Masters moved to Organisation → Masters tab (see OrgMasters).
import IncidentArchived from '../../../components/incidenceReporting/IncidentArchived';
import { IRTabKey } from './IncidenceTabs';

interface IncidenceNetBodyProps {
  activeTab?: IRTabKey;
}

const IncidenceNetBody: React.FC<IncidenceNetBodyProps> = ({ activeTab = 'insights' }) => {
  const renderPanel = () => {
    if (activeTab === 'insights')  return <IncidentInsights />;
    if (activeTab === 'triage')    return <IncidentTriage />;
    if (activeTab === 'archived')  return <IncidentArchived />;
    return <IncidentInsights />;
  };

  return (
    <div className="module-layout">
      <div className="module-main">
        <div className="tab-content">
          <section role="tabpanel" className="tab-panel show">
            {renderPanel()}
          </section>
        </div>
      </div>
    </div>
  );
};

export default IncidenceNetBody;
